module.exports = __webpack_public_path__ + "img/chrono.efd029b7.png";